export default __webpack_public_path__ + "static/media/electrolytes.fd50aa49.svg";